const FaqModal = ({ faqModalRef }) => {
  return (
    <>
      {/* Result Modal */}
      <div className="modal fade" ref={faqModalRef} id="modalFaq" tabIndex="-1" aria-labelledby="modalFaqTitle" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4 py-3">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="modalFaqTitle">Frequently Asked Questions (FAQ)</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="modal-subcontent">

                <h2>What is TripHalal?</h2>
                <p>TripHalal is your personalized halal travel consultant, providing AI-powered travel planning services tailored to your halal lifestyle. We help you plan and book trips that align with your values, making halal travel easier and more accessible.</p>

                <h2>How do I use TripHalal to create a halal itinerary travel plan?</h2>
                <p>Using TripHalal is simple! Just enter your travel destination, budget, length of stay, and number of travelers. Our system will then generate a personalized halal travel itinerary that suits your preferences and needs.</p>

                <h2>Can I make a purchase/booking with TripHalal?</h2>
                <p>Yes, you can! Once you've received your itinerary, simply fill out a booking form, and our team will get in touch to guide you through the next steps. All bookings and purchases are powered by our trusted travel agency partners.</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FaqModal